var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _circle2, _path, _rect29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen06Chat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 72,
    r: 18,
    fill: "#2c7f86",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 62,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 80,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104,
    width: 360,
    height: 1,
    rx: 0,
    fill: "#233142",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 128,
    width: 166,
    height: 44,
    rx: 18,
    fill: "#1a2531",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 142,
    width: 116,
    height: 7,
    rx: 3.5,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 186,
    width: 215,
    height: 44,
    rx: 18,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 200,
    width: 165,
    height: 7,
    rx: 3.5,
    fill: "#05070a",
    opacity: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 244,
    width: 213,
    height: 44,
    rx: 18,
    fill: "#1a2531",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 258,
    width: 163,
    height: 7,
    rx: 3.5,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 302,
    width: 180,
    height: 44,
    rx: 18,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 316,
    width: 130,
    height: 7,
    rx: 3.5,
    fill: "#05070a",
    opacity: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 360,
    width: 150,
    height: 44,
    rx: 18,
    fill: "#1a2531",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 374,
    width: 100,
    height: 7,
    rx: 3.5,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 418,
    width: 173,
    height: 44,
    rx: 18,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 432,
    width: 123,
    height: 7,
    rx: 3.5,
    fill: "#05070a",
    opacity: 0.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 476,
    width: 208,
    height: 44,
    rx: 18,
    fill: "#1a2531",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 490,
    width: 158,
    height: 7,
    rx: 3.5,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 534,
    width: 178,
    height: 64,
    rx: 18,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 548,
    width: 128,
    height: 7,
    rx: 3.5,
    fill: "#05070a",
    opacity: 0.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 566,
    width: 88,
    height: 7,
    rx: 3.5,
    fill: "#05070a",
    opacity: 0.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 688,
    width: 272,
    height: 50,
    rx: 25,
    fill: "#141d27",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 709,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#4b5a68",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 713,
    r: 25,
    fill: "#5ce1e6",
    opacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310,713 L326,713 M320,707 L326,713 L320,719",
    stroke: "#05070a",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen06Chat);
export default __webpack_public_path__ + "static/media/screen-06-chat.16c3357b538fb96fa5bc5ea1ba03d3aa.svg";
export { ForwardRef as ReactComponent };